import { VF_PARAGRAPH } from 'AppSrc/core/components/forms/form-base-components/v-f-paragraph';

const fieldId = 'rootcause-sub-title';

const validator = () => null;

const vFParams = {
  paragraph: 'What caused the change to fail?',
};

const rootcauseSubtitle = {
  id: fieldId,
  validator,
  vFParams,
  fieldType: VF_PARAGRAPH,
};

export { rootcauseSubtitle };
